import CharacterizationScreen from 'app_components/screens/characterization/CharacterizationScreen'
import * as InteractionTypes from 'app_events/interaction/types'
import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'
import './CharacterizationSurveyModal.scss'

interface ICharacterizationSurveyModalProps {
  open: boolean
  onClose: () => void
  data: any
  path?: InteractionTypes.IPathInteraction
}

const CharacterizationSurveyModal: FC<ICharacterizationSurveyModalProps> = ({ open, onClose, data, path }) => {
  return (
    <Modal
      show={open}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName='characterization-survey-modal--dialog'
    >
      <Modal.Body>
        <CharacterizationScreen onFinish={onClose} path={path} resourceData={data} />
      </Modal.Body>
    </Modal>
  )
}

export default CharacterizationSurveyModal
